<script setup lang="ts">
import {ref, getCurrentInstance, onMounted, reactive} from "vue";
import RoomType from "@/models/RoomType";
import RoomFilter from "@/models/RoomFilter";
import {useStore} from "vuex";
import LoadingSpinner from "@/shared/components/loading/LoadingSpinner.vue";
const { $alert } = getCurrentInstance().appContext.config.globalProperties;
const { $axios } = getCurrentInstance().appContext.config.globalProperties;
const { $endpoint } = getCurrentInstance().appContext.config.globalProperties;
// const emit = defineEmits(['searchData'])
const roomTypeList= ref<RoomType[]>([]);
const store = useStore();
const load = ref(false)
  const searchForm = reactive<RoomFilter>({
    arrival:null,
    departure:null,
    guest:1,
    type_appart:null
  })
onMounted(()=>{
  $axios.get($endpoint.LoadRoomType).then((resp_room:any)=>{
    roomTypeList.value = resp_room.data;
  })
})
const getRoomAvailableAtDate = ()=>{
  $axios.post($endpoint.CheckRoomAvailable,searchForm).then((resp_room:any)=>{
    store.dispatch('room_data/saveRoomFound',resp_room.data.data)
  })
  // console.log(event.data.value)
}
  const sendFilterData = ()=>{
  const date_arrival = new Date(searchForm.arrival)
  const date_departure = new Date(searchForm.departure)
  const date_now = new Date()
    if (searchForm.arrival == null|| searchForm.departure == null
        || (date_arrival >= date_departure)
        || (date_arrival.getDate()  < date_now.getDate())
        || (date_departure < date_now)){
      $alert.fire({
        title: 'Ooops!',
        text: 'Veuillez choisir un intervalle de date correct',
        icon: 'error',
        confirmButtonColor:'#D62F2F',
        confirmButtonText: 'Compris'
      })
    }else {
      load.value = true
      store.dispatch('booking_filter/saveRoomFilterData', searchForm)
      getRoomAvailableAtDate()
      load.value =false
    }
  }
  const resetFilter = ()=>{
    load.value = true
    searchForm.departure =null
    searchForm.arrival =null
    searchForm.guest =1
    searchForm.type_appart=null
    store.dispatch('booking_filter/resetRoomFilterData')
    store.state.room_data.roomAvailableData=[]
    store.dispatch('room_data/loadInitialData')
    setTimeout(()=>{
      load.value =false

    },1000)
  }
</script>

<template>
  <!-- BOOKING FORM -->
  <div class="uk-padding bg-color-csa pattern-1 mt-9">
    <div class="uk-container">
      <loading-spinner v-if="load"></loading-spinner>
      <div class="uk-flex uk-flex-center" data-uk-grid>
        <div class="uk-width-1-1">
          <div class="impx-hp-booking-form hp2 no-margin">
            <h6 class="uk-heading-line uk-text-center impx-text-white uk-text-uppercase"><span>Consultez les disponibilités</span></h6>
            <form class="uk-grid-margin-small uk-child-width-1-6@xl uk-child-width-1-6@l
            uk-child-width-1-6@m uk-child-width-1-3@s" data-uk-grid>
              <div class="uk-form-controls">
                <div class="uk-inline">
                  <label class="uk-form-label">Entrée</label>
                  <span class="uk-form-icon" data-uk-icon="icon: calendar"></span>
                  <input class="uk-input booking-arrival uk-border-rounded" v-model="searchForm.arrival" type="date" placeholder="m/dd/yyyy">
                </div>
              </div>
              <div class="uk-form-controls">
                <div class="uk-inline">
                  <label class="uk-form-label">Depart</label>
                  <span class="uk-form-icon" data-uk-icon="icon: calendar"></span>
                  <input class="uk-input booking-departure uk-border-rounded" v-model="searchForm.departure" type="date" placeholder="m/dd/yyyy">
                </div>
              </div>
              <div class="uk-form-controls uk-position-relative">
                <label class="uk-form-label" for="form-guest-select">Invités</label>
                <span class="uk-form-icon select-icon" data-uk-icon="icon: users"></span>
                <select class="uk-select uk-border-rounded" id="form-guest-select" v-model="searchForm.guest">
                  <option value="">Veuillez sélectionné le nombre d'occupants</option>
                  <option :value="pers" :key="pers" v-for="pers in 4">{{pers}} personne(s)</option>
                </select>
              </div>
              <div class="uk-form-controls uk-position-relative">
                <label class="uk-form-label" for="form-rooms-select">Type d'appartement</label>
                <span class="uk-form-icon select-icon" data-uk-icon="icon: album"></span>
                <select class="uk-select uk-border-rounded" id="form-rooms-select" v-model="searchForm.type_appart">
                  <option value="">Veuillez sélectionné un type d'appart</option>
                  <option :value="room_type" :key="index" v-for="(room_type,index) in roomTypeList">{{room_type.room_type_name}}</option>
                </select>
              </div>
              <div>
                <label class="uk-form-label empty-label">&nbsp;</label>
                <button type="button" class="uk-button uk-width-1-1" @click="sendFilterData()">Rechercher</button>
              </div>
                   <button type="button" class="uk-button uk-width-1-5@xl uk-width-1-5@l uk-width-1-2@m uk-width-1-1@s" @click="resetFilter()">Tout les apparts</button>
            </form>
          </div>
        </div>
      </div>

    </div>
  </div>
  <!-- BOOKING FORM END -->
</template>

<style scoped>
.mt-5{
  margin-top:3rem !important;
}
</style>